import { useHomeUrl } from '@/shared/composables/useHomeUrl'
import { PurchaseFlowRoutes } from '@/shared/types/router.types';

type ParamsMappingType = { [key: string]: { name: string; params?: any } }

const redirectToHomePage = () => { window.location.href = useHomeUrl() }
const defaultRedirectMapping: ParamsMappingType = {
  numOfVisitor: {
    name: PurchaseFlowRoutes.TRAVEL_DATE,
  },
  entryType: {
    name: PurchaseFlowRoutes.TRAVEL_DATE,
  },
  travelStartDate: {
    name: PurchaseFlowRoutes.TRAVEL_DATE,
  },
}

export const useHandleRedirect = (fields: string[]) => {
  const missingParam = fields[0]
  return defaultRedirectMapping[missingParam] || redirectToHomePage()
}
